import { formatDisplayDate, formatTimeDisplay} from '../../../../../lib/utils/dateTimeFormat';
import logo256 from '../../../../../assets/img/logo256.png';
import './BookingInvoice.css';

const BookingInvoice = ({ booking }) => {
  if (!booking) return null;
  
  const isGuestBooking = booking.guest_profile_id && !booking.user_id;
  const customerName = isGuestBooking 
    ? `${booking.guest_profiles?.first_name || ''} ${booking.guest_profiles?.last_name || ''}`
    : `${booking.profiles?.first_name || ''} ${booking.profiles?.last_name || ''}`;

  const customerEmail = isGuestBooking 
    ? booking.guest_profiles?.email 
    : booking.profiles?.email;

  const customerPhone = isGuestBooking 
    ? booking.guest_profiles?.phone_number 
    : booking.profiles?.phone_number;

  const today = new Date().toLocaleDateString('en-US', {
    day: '2-digit',
    month: 'short',
    year: '2-digit'
  }).toUpperCase();

  const invoiceNumber = `INV${String(booking.id).padStart(4, '0')}`;

  // Calculate the base price from services_base_prices
  let basePrice = 0;
  if (booking.services?.services_base_price) {
    const priceEntry = booking.services.services_base_price.find(
      price => price.vehicle_types_id === booking.vehicle_type_id
    );
    basePrice = priceEntry?.price || 0;
  }

  // Calculate add-ons total
  const addonsTotal = booking.booking_addons?.reduce((sum, addon) => {
    return sum + (addon.service_addons?.price || 0);
  }, 0) || 0;

  return (
    <div className="booking-invoice">
      <div className="invoice-header">
        <div className="company-logo">
          <img src={logo256} alt="Company Logo" />
          <div className="company-name">INVOICE</div>
        </div>
        <div className="invoice-info">
          <div className="invoice-number">{invoiceNumber}</div>
          <div className="invoice-date">{today}</div>
        </div>
      </div>

      <div className="invoice-addresses">
        <div className="billed-to">
          <div className="label">BILLED TO</div>
          <div className="customer-name">{customerName}</div>
          <div className="contact-info">
            {customerPhone && <div>{customerPhone}</div>}
            {customerEmail && <div>{customerEmail}</div>}
          </div>
        </div>
        <div className="company-info">
          <div className="customer-address">
            {booking.address && booking.location_service === 'atHome' &&
            <>
            {booking.address} 
            </>
            }
            {booking.location_service === 'inStore' &&
            <>
            Serviced at the shop
            </>
            }
          </div>
          <div className="customer-booking-date-time">
            <div>{formatDisplayDate(booking.booking_date) || ''}</div>
            <div>{formatTimeDisplay(booking.booking_time) || ''}</div>
          </div>
        </div>
      </div>

      <div className="invoice-details">
        <table>
          <thead>
            <tr>
              <th>DESCRIPTION</th>
              <th>RATE</th>
              <th>HOURS</th>
              <th>PRICE</th>
            </tr>
          </thead>
          <tbody>
            {/* Combined Vehicle Type and Service */}
            <tr>
              <td>
                <div>
                  <strong>{booking.vehicle_types?.title || 'N/A'} - {booking.services?.name || 'N/A'}</strong>
                </div>
                <div className="service-note">
                  {booking.services?.note && (
                    <small>Note: {booking.services.note}</small>
                  )}
                </div>
              </td>
              <td>${basePrice}</td>
              <td></td>
              <td>${basePrice}</td>
            </tr>

            {/* Add-ons if any */}
            {booking.booking_addons && booking.booking_addons.length > 0 && (
              <>
                <tr>
                  <td colSpan="4">
                    <strong>Additional Services</strong>
                  </td>
                </tr>
                {booking.booking_addons.map((bookingAddon, index) => (
                  <tr key={index}>
                    <td>{bookingAddon.service_addons?.name || 'N/A'}</td>
                    <td>${bookingAddon.service_addons?.price || 0}</td>
                    <td></td>
                    <td>${bookingAddon.service_addons?.price || 0}</td>
                  </tr>
                ))}
              </>
            )}
          </tbody>
        </table>
      </div>

      <div className="invoice-summary">
        <div className="summary-row">
          <span>SERVICE PRICE</span>
          <span>${basePrice}</span>
        </div>
        {addonsTotal > 0 && (
          <>
            <div className="summary-row">
              <span>ADDITIONAL SERVICES</span>
              <span>${addonsTotal}</span>
            </div>
          </>
        )}
        <div className="summary-row total">
          <span>TOTAL AMOUNT DUE</span>
          <span>${booking.total_price}</span>
        </div>
      </div>

      <div className="invoice-footer">
        <div className="thank-you">THANK YOU FOR YOUR BUSINESS!</div>
        <div className="company-details">
          <span>rkollie3@pmcardetailing.com</span>
          <span>+1 (701) 893-6853</span>
          <span>1327 3rd Ave N Fargo, ND 58102</span>
        </div>
      </div>
    </div>
  );
};

export default BookingInvoice;
